const TetherCnt = {
  symbol: "WIN",
  name: "winkLink",
  meta: {
    title: "Buy winkLink | Sell winkLink | winkLink prices and charts",
    description:
      "Wink is a gaming platform that allows users to play, socialize and share across multiple blockchain ecosystems. At coinnik Market, buy and sell Wink at the best price, lowest commission and fastest time",
    keywords: "winkLink, buy winkLink, sell winkLink, winkLink price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: " چگونه وینک بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید بایننس کوین کنید. قیمت وینک در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول وینک کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "برای ذخیره وینک می‌توانید از انواع کیف‌پول‌های معتبر استفاده کنید. توکن وینک رمز ارزی با استاندارد trc20 است در نتیجه می‌توانید برای نگهداری از آن کیف‌پول‌های ترون را استفاده کنید.",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین‌نیک مارکت امکان نگهداری وینک وجود دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در کوین‌نیک مارکت یک کیف پول اختصاصی و امن دارید، که می‌توانید رمزارزهیاتان را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا وینک ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " با توجه به اینکه پروژه‌های بازی در دنیای کریپتو بسیار مورد توجه قرار گرفته شده و از آینده خوبی نیز برخوردارند، می‌توان گفت که وینک نیز ارزش زیادی برای سرمایه‌گذاری دارد.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy Wink",
      answer:
        "In coinnik Market trading platform, you can buy Wink with Shetab member bank card and the lowest fee. The price of Wink in coinnik Market is determined by you.",
      id: "toggler1",
    },
    {
      question: "What is the best Wink wallet?",
      answer: "Wink_wallet_description",
      id: "toggler2",
    },
    {
      question: "Can I keep a Wink at coinnik Market?",
      answer: "Keep_Wink_description",
      id: "toggler3",
    },
    {
      question: "Is Wink worth the investment?",
      answer: "Wink_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about Wink",
        subTitle: "What is Wink?",
        content: "Wink_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of Wink",
        content: "Wink_history_description",
        btnTitle: "Buy and sell Wink",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle: "Buy and sell Wink without intermediaries in coinnik Market",
        subTitle: "Buy Wink",
        content: "Buy_Wink_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell Wink",
        content: "Sell_Wink_description",
        btnTitle: "Buy and sell Wink",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest Wink analysis on the blog",
  informationTitle: "Wink market statistics and information",
};

export default TetherCnt;
